import {Component, ElementRef, Input, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {DataSetVO} from "../exports";
import {TranslateService} from '@ngx-translate/core';
declare const timeSheet: any;
@Component({
  selector: 'app-viewblocks',
  templateUrl: './viewblocks.component.html',
  styleUrls: ['./viewblocks.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class ViewblocksComponent implements OnInit {
  dataAllBlocks:DataSetVO
  @Input()
  index:number;

  @Input()
  set data(data: DataSetVO) {
    setTimeout(() => {
      this.dataAllBlocks = data;
      this.draw(data);
    }, 1)
  }
  @ViewChild('block') block: ElementRef;
  timeSheet: any;
  config: any = {
    styles: {
      header: {
        fontSize: '12px',
        fontWeight: '200',
      },
      block: {
        bottomLine: 30,
        height: 12,
        colorLine: '#f3f3f3',
        colorAxe: '#f3f3f3',
        borderRadius: '30px'
      }
    },
    template: {
      block: (block) => {
        const {data, start, end, color,idTest} = block;
        const {label} = data || {label: null};
        return timeSheet.nano('<div class="popup-view" data-test-id="' + idTest + '">' +
          '<div style="background: {color}">{label}</div>' +
          '<div>{start} - {end}</div>' +
          '</div>', {start, end, label, color})
      }
    },
    events: {
      line: {
        onClick: (context, data, ev) => {
          const el = ev.target
          const x  = el.offsetLeft + el.offsetWidth / 2;
          const date = context.getHoursX(x);

          timeSheet.dialog('<h2>{id}</h2>', {
            id: date
          }, {
            openFrom: ev.target
          })
        }
      },
      block: {
        onClick: function (data) {
          console.log(data)
        },
        onHover: function (data) {}
      }
    }
  }


  constructor(private translate: TranslateService) {
    translate.onLangChange.subscribe(() => {
      this.draw(this.dataAllBlocks);
    })
  }

  ngOnInit() {
  }

  click(data) {
    console.log(data)
  }
  draw(options: any) {
    if(!this.block.nativeElement) return;
    if (options.data) options.data.forEach(d=> d.index = this.index);
    this.timeSheet = new timeSheet({
      selector: this.block.nativeElement,
      timeZone:  0,
      resize: true,
      data: options.data || [],
      interval: options.interval,
      ...this.config
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/injection/viewblocks/viewblocks.component.ts